import styled, { keyframes, css } from 'styled-components';

const shake = keyframes`
    25% { transform: translateX(5px); }
    50% { transform: translateX(-5px); }
    75% { transform: translateX(5px); }
`;

const shakeOnInvalid = css`
    &.invalid-input {
        animation: ${shake} 0.2s 2;

        input, button {
            border-color: ${(p) => p.theme.danger};
        }
    }
`;

/* ─── Champ de recherche utilisateur ─── */
export const SearchField = styled.div`
    position: relative;
    max-width: 420px;
    ${shakeOnInvalid}
`;

export const SearchInput = styled.input`
    width: 100%;
    padding: 7px 34px 7px 10px;
    font-family: inherit;
    font-size: 0.85rem;
    color: ${(p) => p.theme.text};
    background: ${(p) => p.theme.surface};
    border: 1px solid ${(p) => p.theme.borderStrong};
    border-radius: ${(p) => p.theme.radius.sm};
    transition: border-color 0.12s ease;

    &:focus {
        outline: none;
        border-color: ${(p) => p.theme.accent};
    }
    &::placeholder {
        color: ${(p) => p.theme.text3};
    }
`;

export const SearchIcon = styled.i`
    position: absolute;
    right: 9px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.05rem;
    color: ${(p) => p.theme.text3};
    pointer-events: none;
`;

export const SuggestionsList = styled.ul`
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    z-index: 50;
    margin: 0;
    padding: 4px;
    list-style: none;
    max-height: 260px;
    overflow-y: auto;
    background: ${(p) => p.theme.surface};
    border: 1px solid ${(p) => p.theme.border};
    border-radius: ${(p) => p.theme.radius.sm};
    box-shadow: ${(p) => p.theme.shadowMd};
`;

export const SuggestionItem = styled.li`
    padding: 7px 10px;
    font-size: ${(p) => p.theme.type.table};
    border-radius: ${(p) => p.theme.radius.sm};
    cursor: pointer;
    transition: background 0.12s ease;

    &:hover {
        background: ${(p) => p.theme.surface3};
    }
`;

export const SelectedUser = styled.div`
    display: flex;
    align-items: center;
    gap: 7px;
    max-width: 420px;
    padding: 6px 10px;
    font-size: ${(p) => p.theme.type.caption};
    background: ${(p) => p.theme.accentSoft};
    color: ${(p) => p.theme.accentText};
    border-radius: ${(p) => p.theme.radius.sm};

    i { font-size: 1.05rem; flex-shrink: 0; }
`;

/* ─── Sélecteur multiple d'étoiles ─── */
export const MultiSelect = styled.div`
    position: relative;
    max-width: 420px;
    ${shakeOnInvalid}
`;

export const MultiSelectButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
    padding: 7px 10px;
    font-family: inherit;
    font-size: 0.85rem;
    text-align: left;
    color: ${(p) => p.theme.text};
    background: ${(p) => p.theme.surface};
    border: 1px solid ${(p) => p.theme.borderStrong};
    border-radius: ${(p) => p.theme.radius.sm};
    cursor: pointer;
    transition: background 0.12s ease;

    &:hover:not(:disabled) {
        background: ${(p) => p.theme.surface3};
    }
    &:disabled {
        color: ${(p) => p.theme.text3};
        background: ${(p) => p.theme.surface2};
        cursor: not-allowed;
    }
`;

export const ChevronIcon = styled.i`
    font-size: 1.15rem;
    flex-shrink: 0;
    color: ${(p) => p.theme.text2};
    transition: transform 0.15s ease;
    transform: rotate(${(p) => (p.$isOpen ? '180deg' : '0deg')});
`;

export const MultiSelectList = styled.ul`
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    z-index: 50;
    margin: 0;
    padding: 4px;
    list-style: none;
    max-height: 280px;
    overflow-y: auto;
    background: ${(p) => p.theme.surface};
    border: 1px solid ${(p) => p.theme.border};
    border-radius: ${(p) => p.theme.radius.sm};
    box-shadow: ${(p) => p.theme.shadowMd};
`;

export const MultiSelectItem = styled.li`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 7px 10px;
    font-size: ${(p) => p.theme.type.table};
    border-radius: ${(p) => p.theme.radius.sm};
    cursor: pointer;
    transition: background 0.12s ease;
    background: ${(p) => (p.$selected ? p.theme.accentSoft : 'transparent')};
    color: ${(p) => (p.$selected ? p.theme.accentText : p.theme.text)};

    &:hover {
        background: ${(p) => (p.$selected ? p.theme.accentSoft : p.theme.surface3)};
    }

    i { font-size: 1.1rem; flex-shrink: 0; }
`;
